import checkbox from './checkbox'
import radio from './radio'

export {
    checkbox,
    radio
}



// WEBPACK FOOTER //
// ./src/components/check/index.js